<router-outlet></router-outlet>
<ngx-ui-loader [fgsColor]="ngxUIconfig.fgsColor" [text]="ngxUIconfig.text" [overlayColor]="ngxUIconfig.overlayColor"></ngx-ui-loader>
<div id="dummyDiv"></div>